<div class="d-flex flex-inline navigation-container">
    <ng-container *ngFor="let item of navigationItems">
        <app-vst-navigation-item *ngIf="item.profileRequired == null || item.profileRequired === profile?.type"
            [item]="item"></app-vst-navigation-item>
    </ng-container>

    <div class="d-flex align-items-center ms-2" *ngIf="profile" (click)="requestLogout()"><i
            class="fas fa-sign-out-alt logout-icon"></i> <span class="ms-1" translate>navigation.logout</span></div>
</div>